import baseService from './baseService'

export function GetIncomeStatementAccountsData(param) {
    return baseService.get("/api/IncomeStatement/GetIncomeStatementAccounts?" + param);
};

export function GetArchivedIncomeStatement(body) {
    return baseService.post("/api/IncomeStatement/archiveList", body)
};

export function UpdateAccountsCommentNotes(data) {
    return baseService.put("/QuickbookAccount/UpdateRTDateAndComments", data);
}

export function UpdateAccountsQuestion(data) {
    return baseService.post("/QuestionsAndComments/AddQuestion", data);
};

export function MarkAsReviewed(data) {
    return baseService.post("/api/IncomeStatement/IncomeStatementMarkAsReviewed", data)
}

export function GetMarkAsReviewedHistoryList(data) {
    return baseService.post("/api/IncomeStatement/GetIncomeStatementReviewedHistoryList", data)
}

export function GetMarkAsReviewedHistoryById(param) {
    return baseService.get("/api/IncomeStatement/GetIncomeStatementReviewedHistoryById", { params: param });
}

export function EditReviewedAccountCustomField(body) {
    return baseService.post("/api/IncomeStatement/EditReviewedAccountCustomField", body);
}